<app-background backgroundImage="images/shared/backgrounds/background-1.avif">
    <h1 class="sr-only">Healthcare App Marketing — HIPAA-Aware User Acquisition for Telehealth and Wellness Apps</h1>
    <app-hero-section height="520px" paddingTop="300px" opacity=".8"
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" [title]="`images/${file}/${file}.svg`"
        text="service"></app-hero-section>
    <app-healthcare-process></app-healthcare-process>
    <app-healthcare-choose-us></app-healthcare-choose-us>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-2.avif">
    <app-info>
        <div class="flex flex-col justify-center items-center">
            <div class="font-outfit text-xl sm:text-3xl font-semibold mb-2 sm:mb-6">
                let's transform your healthcare business <span class="gradient-text">together</span>
            </div>
            <div class="font-inter mb-6 sm:mb-[21px] text-center text-sm sm:text-base">
                Your Vision. Our Expertise. Let's Build Something Great Together.<br><br>
                We're here to help you create and market innovative apps, from diet apps to telemedicine platforms. Get
                in touch today, and let's turn your project into a success.
            </div>
            <app-button buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
        </div>
    </app-info>
    <app-healthcare-card-number-container></app-healthcare-card-number-container>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <div class="h-[20px]"></div>
    <app-connect></app-connect>
</app-background>